import React from 'react';
import { observer } from 'mobx-react-lite';

import machineOff from '../../../assets/images/game/machine-off.png';
import machineOn from '../../../assets/images/game/machine-on.png';

import { gameStore } from '../../../store';

const GameMachineSection = observer(() => {
  const { isBetsClosed, stopLight } = gameStore;

  return (
    <div className='monti-game-machine-holder'>
      <div
        className={`monti-game-machine ${isBetsClosed ? 'active' : ''} ${
          stopLight ? 'paused-anim' : ''
        }`}
      >
        <div className='monti-game-machine-details'>
          <div className='machine-detail m-t-shadow'>
            <div className='m-t-shadow-inside' />
          </div>
          <div className='machine-top-lights'>
            <div className='machine-light' />
            <div className='machine-light' />
            <div className='machine-light' />
            <div className='machine-light' />
            <div className='machine-light' />
          </div>
          <div className='machine-detail m-t-light' />
          <div className='machine-light-shadow top' />
          <div className='machine-light-shadow bottom' />
          <div className='machine-detail m-b-light' />
          <div className='machine-bottom-lights'>
            <div className='machine-light' />
            <div className='machine-light' />
            <div className='machine-light' />
            <div className='machine-light' />
            <div className='machine-light' />
          </div>
          <div className='machine-detail m-b-shadow'>
            <div className='m-b-shadow-inside' />
          </div>
          <div className='monti-game-machine-bg-holder'>
            <img className='monti-game-machine-bg off' src={machineOff} alt='' />
            <img className='monti-game-machine-bg on' src={machineOn} alt='' />
          </div>
        </div>
      </div>
    </div>
  );
});

export default GameMachineSection;
